import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card mb-2" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "mb-0" }
const _hoisted_5 = ["data-target", "aria-controls"]
const _hoisted_6 = ["id", "aria-labelledby", "data-parent"]
const _hoisted_7 = { class: "card-body px-5 px-lg-6 py-lg-5" }
const _hoisted_8 = { class: "accordion-select__item" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SidebarMenuItem = _resolveComponent("SidebarMenuItem")

  return (_openBlock(), _createElementBlock("div", {
    class: "accordion accordion-select",
    id: $options.accordionId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "card-header p-0",
        id: 'heading-' + $options.accordionId
      }, [
        _createElementVNode("h2", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-block text-left btn--primary color--gray-700 border--2",
            type: "button",
            "data-toggle": "collapse",
            "data-target": '#collapse-' + $options.accordionId,
            "aria-expanded": "false",
            "aria-controls": '#collapse-' + $options.accordionId
          }, _toDisplayString($options.selectedLabel), 9 /* TEXT, PROPS */, _hoisted_5)
        ])
      ], 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", {
        id: 'collapse-' + $options.accordionId,
        class: "collapse",
        "aria-labelledby": 'heading-' + $options.accordionId,
        "data-parent": '#' + $options.accordionId
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, (item) => {
              return (_openBlock(), _createBlock(_component_SidebarMenuItem, {
                item: item,
                key: item.id
              }, null, 8 /* PROPS */, ["item"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ], 8 /* PROPS */, _hoisted_6)
    ])
  ], 8 /* PROPS */, _hoisted_1))
}